var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.834 17.5v-1.667a3.335 3.335 0 0 0-2.5-3.228m-2.917-9.863a3.334 3.334 0 0 1 0 6.182m1.25 8.576c0-1.553 0-2.33-.254-2.942a3.334 3.334 0 0 0-1.804-1.804c-.612-.254-1.389-.254-2.942-.254h-2.5c-1.553 0-2.33 0-2.942.254a3.333 3.333 0 0 0-1.804 1.804c-.254.612-.254 1.389-.254 2.942M11.75 5.833a3.333 3.333 0 1 1-6.666 0 3.333 3.333 0 0 1 6.666 0z",
    stroke: "#667085",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers01);
export default __webpack_public_path__ + "static/media/users01.b1f189391a6d49a9a39e0e22456d2e3b.svg";
export { ForwardRef as ReactComponent };